import { render } from "./2CommercialSharkFinning.vue?vue&type=template&id=89b01532"
import script from "./2CommercialSharkFinning.vue?vue&type=script&lang=js"
export * from "./2CommercialSharkFinning.vue?vue&type=script&lang=js"
script.render = render

export default script